module.exports = __webpack_public_path__ + "static/media/josh-avatar.bf5655c2.svg";